let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8sBAZ")).then(() => parcelRequire('5iMns'));